/** Bundled content failed validation. The game must refuse to start (docs/ARCHITECTURE.md §13). */
export class ContentValidationError extends Error {
  override readonly name = 'ContentValidationError'
}
